import { RouteConfig } from "vue-router";

export const AskCenAiRouter = (): RouteConfig[] => [
  {
    path: "/ask-cenai",
    name: "AskCenAiPage",
    component: () => import("@/features/askCenAi/pages/AskCenAiPage.vue"),
  },
];
